<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n({ inheritLocale: true })

useHead({
  htmlAttrs: {
    lang: locale,
  },
})
</script>

<template>
  <v-app>
    <router-view />
  </v-app>
</template>

